import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { Author } from '../models/Author';
import { ISignalBoConfiguration } from '../models/ISignalBoConfiguration';
import { AuthorService } from '../services/author.service';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlerService } from '../services/errorHandler.service';

@Injectable()
export class SignalBoConfiguration {

  public ApiUrl: string;
  public MessageEndpoint: string;
  public ImagesStorageName: string;
  public ImagesContainerName: string;
  public ImagesPublicContainerName: string;
  public ImagesFolderPath: string;
  public AllowedContentTypes: string[];
  public MessagePageSize: number;

  private allowedAuthors: string[];

  constructor(private authorService: AuthorService, private errorHandler: ErrorHandlerService) {

    var config: ISignalBoConfiguration = APP_SETTINGS.SignalBoConfig;

    this.ApiUrl = config.ApiUrl;
    this.MessageEndpoint = config.MessageEndpoint;
    this.ImagesContainerName = config.ImagesContainerName;
    this.ImagesStorageName = config.ImagesStorageName;
    this.ImagesPublicContainerName = config.ImagesPublicContainerName;
    this.ImagesFolderPath = config.ImagesFolderPath;
    this.AllowedContentTypes = config.AllowedContentTypes;
    this.MessagePageSize = config.MessagePageSize;
    this.allowedAuthors = config.AllowedAuthors;
  }

  public GetAllowedAuthors(): Observable<Author[]>{
    return this.authorService.GetAuthors()
    .pipe(
      map(response => this.filterAuthors(response)),
        catchError(this.errorHandler.handleError<object[]>('AuthorService_GetAuthors', []))
    );
  };

  filterAuthors(authors){
    const allowedAuthors = this.allowedAuthors;
    return authors.filter(function(author){
           return allowedAuthors.includes(author.AuthorId);
         });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/configuration/SignalBoConfiguration.ts